import { Logo } from "./components/logo"
import { NavButtons } from "./components/NavButtons"
import { SocialLinks } from "./components/SocialLinks"

export default function Home() {
  return (
    <main className="relative min-h-svh flex items-center justify-center overflow-hidden bg-background">
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('/backgroundImage.jpg')" }}
        aria-hidden="true"
      />
      {/* Overlay to darken and tint */}
      <div className="absolute inset-0 bg-background/60" aria-hidden="true" />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center gap-10 md:gap-14 py-16 px-4 w-full">
        <Logo />
        <NavButtons />
        <SocialLinks />
      </div>
    </main>
  )
}
